import collection from "@/store/dynamic-collection.store-partial";
import planModule from "@/store/game/plans/single.store";
import { LOCAL } from "@/store/mutations";

const { SET_PLAN_SELECTION, TRACK_REFUND_STATE } = LOCAL;

export default {
	namespaced: true,
	modules: {
		collection,
	},
	state: {
		selectedID: false,
		refunding: false,
	},
	getters: {
		selected: (state) => state[state.selected],
		owned: (state, getters) => getters.array.filter((plan) => plan.owned)
			.sort((planA, planB) => getters.typeOrder(planA.type) - getters.typeOrder(planB.type)),
		typeOrder: (state, getters, rootState) => (type) => rootState.game.insurance[type].order,
		available: (state, getters, rootState) => getters.array.filter(
			(plan) => rootState.game.insurance.viewing === plan.type
		),
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, { plans }) {
				await dispatch("collection/populate", { items: plans, multiple: true, module: planModule });
			},
		},
		select({ commit, dispatch, getters }, selection) {
			const plan = getters.getById(selection.id);
			dispatch("collection/activate", { ...plan, path: ["game", "plans", "selected"] });
			commit(SET_PLAN_SELECTION, plan);
		},
		deselect({ commit, dispatch, state }) {
			// called from the `beforeEnter` lifecycle hook from SpinsView and Cart
			if (state.selectedID) {
				dispatch("collection/deactivate", { path: ["game", "plans", "selected"] });
			}

			commit(SET_PLAN_SELECTION, { id: false });
		},
		async purchase({ dispatch, commit, state }) {
			dispatch("selected/purchase");
			const plan = { ...state.selected };
			dispatch("collection/activate", { ...plan, path: ["game", "plans", plan.type] });

			// We should deselect the plan here, but it causes vue errors in the departing Addons.vue
			// so for now (forever?) it gets called in Addons.vue during the `beforeEnter` methood in
			// spin.routes.js for the main SpinView.  It used to live in the Addons.vue destroyed method
			// but this caused the plan to reset when goinhg from addons back to plan selection.

			commit(TRACK_REFUND_STATE, { id: false });
		},
		async refund({ dispatch, commit, state, rootState }, insurance) {
			// Refund State is tracked only so that we can pre-select the last plan when loading Plans.Vue.
			commit(TRACK_REFUND_STATE, state[`${insurance.id}`]);
			await dispatch(`${insurance.id}/refund`);
			await dispatch("collection/deactivate", {
				path: ["game", "plans", insurance.id],
				state: rootState.global.api.data.plans[state.refunding],
			});
		},
		reset({ dispatch, rootState, getters }) {
			getters.owned.forEach((plan) => {
				dispatch(`${plan.type}/remove`);
				dispatch("collection/deactivate", {
					path: ["game", "plans", plan.type],
					state: rootState.global.api.data.plans[plan.id],
				});
			});
		},
	},
	mutations: {
		[SET_PLAN_SELECTION](state, selected) {
			state.selectedID = selected.id;
		},
		[TRACK_REFUND_STATE](state, plan) {
			state.refunding = plan.id;
		},
	},
};
